'use strict';

var _excluded = ["start", "end"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _ = require('lodash');

var d3Scale = require('d3-scale');

var d3Array = require('d3-array');

var moment = require('moment-timezone');

var _require = require('./sample-mapping'),
    numericalValueKeys = _require.numericalValueKeys,
    isNumericalProperty = _require.isNumericalProperty;

var hardwareUtils = require('./hardware');

var snapshotUtils = require('./snapshot');

var _require2 = require('./url'),
    addParamsToUrl = _require2.addParamsToUrl;

var _require3 = require('../lib/errors'),
    BadRequestError = _require3.BadRequestError;

var _require4 = require('./formatters'),
    useSignificantDigits = _require4.useSignificantDigits;

var allowedTimeUnits = {
  s: 1,
  m: 60,
  h: 60 * 60,
  d: 60 * 60 * 24,
  w: 60 * 60 * 24 * 7,
  mo: 60 * 60 * 24 * 30,
  y: 60 * 60 * 24 * 365
};
var resolutionsMap = new Map([['d', 60 * 60 * 24], ['h', 60 * 60], ['5m', 60 * 5], ['m', 60]]);
var allowedResolutions = {};

var _iterator = _createForOfIteratorHelper(resolutionsMap),
    _step;

try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];

    allowedResolutions[key] = val;
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

function getRangeMagnitude(timeString) {
  var magnitude = timeString === 'all' ? Math.floor(Date.now() / 1000) : parseInt(timeString.match(/^([0-9]*)/), 10);
  return !isNaN(magnitude) ? magnitude : 1;
}

function getRangeUnit(timeString) {
  var unit = timeString === 'all' ? 'm' : timeString.match(/([a-z])*$/ig);

  if (unit) {
    unit = unit[0].toLowerCase();
  }

  if (Object.keys(allowedTimeUnits).indexOf(unit) > -1) {
    return unit;
  }
}

function parseTimeString(timeString) {
  var magnitude = getRangeMagnitude(timeString);
  var unit = getRangeUnit(timeString);

  if (isNaN(magnitude)) {
    throw new BadRequestError("Could not parse magnitude for timeString \"".concat(timeString, "\""));
  }

  if (!unit) {
    throw new BadRequestError("Could not parse unit for timeString \"".concat(timeString, "\""));
  }

  return {
    magnitude: magnitude,
    unit: unit,
    seconds: magnitude * allowedTimeUnits[unit]
  };
}

function interpolateMissingTimestampedSnapshots(_ref) {
  var timestampedSnapshots = _ref.timestampedSnapshots,
      start = _ref.start,
      end = _ref.end,
      resolution = _ref.resolution;
  var stepSeconds = parseTimeString(resolution).seconds;

  if (!timestampedSnapshots.length || timestampedSnapshots.length === (end - start + 1) / stepSeconds) {
    return timestampedSnapshots;
  }

  var i = -1; // step through all possible snapshot times and interpolate missing data

  var _loop = function _loop(t) {
    i = i + 1;
    var currentTimestampedSnapshot = timestampedSnapshots.slice(i).find(function (ts) {
      return ts.t === t;
    }); // found a timestampted snapshot, so no need to interpolate

    if (currentTimestampedSnapshot) {
      return "continue";
    } // no timestamped snapshot found, so interpolate based on nearby data


    var prev = timestampedSnapshots[i - 1];
    var next = timestampedSnapshots[i];

    if (prev && !next) {
      next = prev;
    }

    if (next && !prev) {
      prev = next;
    }

    var valueScale = d3Scale.scaleLinear().domain([prev.t, next.t]); // insert new snapshot

    timestampedSnapshots.splice(i, 0, {
      t: t,
      c: prev.c.map(function (r, j) {
        numericalValueKeys.forEach(function (k) {
          var prevValue = r[k];
          var nextValue = next.c[j][k];

          if (!isNaN(prevValue) && !isNaN(nextValue)) {
            valueScale.range([prevValue, nextValue]);
            r[k] = valueScale(t);
          }
        });
        return r;
      })
    });
  };

  for (var t = start; t <= end; t += stepSeconds) {
    var _ret = _loop(t);

    if (_ret === "continue") continue;
  }

  return timestampedSnapshots;
}

function mergeTimestampedSnapshots(snapshotsWithTimestamps) {
  return snapshotsWithTimestamps.reduce(function (acc, v) {
    var snapshotWithSameTimestamp = acc.find(function (s) {
      return s.t === v.t;
    });

    if (snapshotWithSameTimestamp) {
      snapshotWithSameTimestamp.c = snapshotWithSameTimestamp.c.concat(v.c);
    } else {
      acc.push(v);
    }

    return acc;
  }, []);
}

function mapSnapshotsWithTimestampsToTimeSeries(snapshotsWithTimestamps) {
  if (!snapshotsWithTimestamps.length) return []; // create an empty timeSeries object from the snapshot that has the most circuits

  var timeSeries = snapshotUtils.getSnapshotWithMostData(snapshotsWithTimestamps.map(function (s) {
    return s.c;
  })).map(function (c) {
    var r = {
      label: c.label,
      id: c.id
    };
    ['grid', 'production', 'battery', 'other', 'circuit_type'].forEach(function (key) {
      if (c[key]) {
        r[key] = c[key];
      }
    });
    r.main = hardwareUtils.registerIsMain(r);
    r.values = [];
    return r;
  }); // iterate through all snapshots

  snapshotsWithTimestamps.forEach(function (s) {
    // iterate through all circuits and add them to values array
    s.c.forEach(function (c, i) {
      // TODO - this depends on id always being present
      var matchingCircuit = timeSeries.find(function (circuit) {
        return circuit.id && circuit.id === c.id;
      });

      if (matchingCircuit) {
        matchingCircuit.values.push({
          t: s.t,
          w: c.w
        });
      }
    });
  });
  return timeSeries.filter(function (c) {
    return hardwareUtils.registerIsConfigured(c) && c.id && c.values && c.values.length;
  });
}

function addTimeSeriesTotals(timeSeries) {
  var hasProduction = timeSeries.find(hardwareUtils.registerIsProduction);
  var hasBattery = timeSeries.find(hardwareUtils.registerIsBattery);

  if (hasProduction || hasBattery) {
    timeSeries.push({
      label: 'Grid impact',
      total: true,
      values: getNetSeries(timeSeries)
    });
  }

  if (hasProduction) {
    timeSeries.push({
      label: 'Total production',
      total: true,
      values: getProductionSeries(timeSeries)
    });
  }

  if (hasBattery) {
    timeSeries.push({
      label: 'Total storage',
      total: true,
      values: getBatterySeries(timeSeries)
    });
  } // consumption


  timeSeries.push({
    label: 'Total consumption',
    total: true,
    values: getConsumptionSeries(timeSeries)
  });
  return timeSeries;
}

function sumTimeSeriesWattage(timeSeries, options) {
  options = _objectSpread({
    removeEmpties: false
  }, options);
  var _options = options,
      removeEmpties = _options.removeEmpties;

  if (!timeSeries || !timeSeries.length) {
    return [];
  }

  if (removeEmpties) {
    timeSeries = timeSeries.map(function (r) {
      r.values = r.values.filter(function (v) {
        return v.hasOwnProperty('w');
      });
      return r;
    });
  }

  ;
  var valueGroups = timeSeries.map(function (circuit) {
    return circuit.values.map(function (values) {
      return values.w;
    });
  }); // find the group with the most data points and use that as our base

  return snapshotUtils.getSnapshotWithMostData(valueGroups).map( // sum values, and use 0 if value is not found
  function (val, i) {
    return valueGroups.map(function (group) {
      return group[i] || 0;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  });
}

function omitPartialSnapshots(snapshots, circuitIds) {
  return snapshots.filter(function (s) {
    var snapshotCircuitIds = s.c.map(function (c) {
      return c.id;
    });
    return circuitIds.every(function (circuitId) {
      return snapshotCircuitIds.includes(circuitId);
    });
  });
}

function interpolatePartialSnapshots(snapshots) {
  // sort by timestamp
  snapshots = snapshots.sort(function (a, b) {
    return a.t - b.t;
  }); // get a unique list of every circuit present in the array of snapshots 

  var allCircuits = snapshots.reduce(function (acc, v) {
    return acc.concat(v.c.filter(function (c) {
      return !acc.find(function (existingCircuit) {
        return existingCircuit.id === c.id;
      });
    }));
  }, []); // for a given snapshot, get the nearest item 

  var getNearbySnapshot = function getNearbySnapshot(index, circuitId, asc) {
    var iterationLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
    var i = index;
    var iterateCount = 0;

    var iterate = function iterate() {
      if (iterateCount >= iterationLimit) {
        // too many iterations
        return null;
      }

      i = asc ? i + 1 : i - 1;
      var snapshot = snapshots[i];
      iterateCount += 1;

      try {
        // we found a snapshot that contains our circuit
        if (snapshot.c.find(function (c) {
          return c.id === circuitId;
        })) {
          return snapshot;
        }
      } catch (err) {
        // we probably went out of bounds and got an undefined
        return null;
      }

      return iterate();
    };

    return iterate();
  };

  snapshots.forEach(function (snapshot, i) {
    // for each snapshot, check every circuit that should exist
    allCircuits.forEach(function (circuit) {
      var preExistingCircuitInSnapshot = snapshot.c.find(function (c) {
        return c.id === circuit.id;
      });

      var matchingCircuitInSnapshot = preExistingCircuitInSnapshot || _objectSpread(_objectSpread({}, circuit), {}, {
        w: null
      }); // if the snapshot has no data for the current circuit, build one 


      if (!preExistingCircuitInSnapshot) {
        snapshot.c.push(matchingCircuitInSnapshot);
      }

      if (typeof matchingCircuitInSnapshot.w !== 'number') {
        matchingCircuitInSnapshot.w = 0;

        try {
          // try to find previous snapshot that has the current circuit
          var prevSnapshot = getNearbySnapshot(i, circuit.id, false); // if we are near the beginning of the data set, then there is a chance
          // so going backward could take you out of bounds, go forward instead

          if (!prevSnapshot && i < 1) {
            prevSnapshot = getNearbySnapshot(i + 1, circuit.id, true);
          }

          var nextSnapshot = getNearbySnapshot(i, circuit.id, true); // if we are near the end of the data set, then there is a chance
          // so going forward could take you out of bounds, go backward instead

          if (!nextSnapshot && i > snapshots.length - 2) {
            nextSnapshot = getNearbySnapshot(i - 1, circuit.id, false);
          }

          var prevValue = prevSnapshot.c.find(function (c) {
            return c.id === circuit.id;
          }).w;
          var nextValue = nextSnapshot.c.find(function (c) {
            return c.id === circuit.id;
          }).w;

          var _dt = (snapshot.t - prevSnapshot.t) / (nextSnapshot.t - prevSnapshot.t);

          matchingCircuitInSnapshot.w = Math.round(prevValue + _dt * (nextValue - prevValue));
        } catch (err) {//
        }
      }
    });
  });
  return snapshots;
}

function fillDataGapsInTimeSeries(timeSeries) {
  // grab every timestamp present in the data
  if (!timeSeries || !timeSeries.length) {
    return [];
  }

  var allTimestamps = timeSeries.reduce(function (acc, c) {
    return acc.concat(c.values.map(function (v) {
      return v.t;
    }).reduce(function (a, t) {
      if (a.indexOf(t) === -1) {
        a.push(t);
      }

      return a;
    }, []).filter(function (t) {
      return acc.indexOf(t) === -1;
    }));
  }, []); // for any circuit that is missing a timestamp, insert a value for it where w is 0

  timeSeries.forEach(function (c) {
    allTimestamps.forEach(function (t, i) {
      if (!c.values.find(function (v) {
        return v.t === t;
      })) {
        var prevItem = c.values[i - 1];
        var nextItem = c.values[i + 1]; // placeholder for value that will be filled

        var filledItem = {
          t: t
        };

        try {
          if (!prevItem) {
            //
            filledItem.w = nextItem.w;
          } else if (!nextItem) {
            //
            filledItem.w = prevItem.w;
          } else {
            dt = t / (nextItem.t - prevItem.t);
            dy = (nextItem.w - prevItem.w) * dt;
            filledItem.w = prevItem.w + dy;
          }
        } catch (err) {
          filledItem.w = 0;
        }

        c.values.splice(i, 0, filledItem);
      }
    });
  });
  return timeSeries;
} // returns an array of wattage values


function getMainsSummed(timeSeries) {
  var timeSeriesMains = timeSeries.filter(hardwareUtils.registerIsMain); // if no mains exist, just send an array of 0s, keeping the math simple

  if (timeSeries.length && !timeSeriesMains.length) {
    return timeSeries[0].values.map(function () {
      return 0;
    });
  }

  return timeSeries.length ? sumTimeSeriesWattage(timeSeriesMains) : [];
}

function getWattsForTimestamp(series, t) {
  var matchingValue = series.find(function (v) {
    return v.t === t;
  });
  return matchingValue ? matchingValue.w || 0 : 0;
}

;

function getConsumptionSeries(timeSeries) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var gridSeries = getNetSeries(timeSeries);
  var productionSeries = getProductionSeries(timeSeries);
  var batterySeries = getBatterySeries(timeSeries);
  return snapshotUtils.getSnapshotWithMostData([gridSeries, productionSeries, batterySeries]).map(function (value) {
    return {
      t: value.t,
      w: getWattsForTimestamp(gridSeries, value.t) - getWattsForTimestamp(productionSeries, value.t) - getWattsForTimestamp(batterySeries, value.t)
    };
  });
}

function multiplyTimeSeries(timeSeries) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$multiplier = _ref2.multiplier,
      multiplier = _ref2$multiplier === void 0 ? 1 : _ref2$multiplier,
      _ref2$metric = _ref2.metric,
      metric = _ref2$metric === void 0 ? 'w' : _ref2$metric;

  return timeSeries.map(function (r) {
    if (!r.hasOwnProperty(metric)) {
      return r;
    }

    return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, metric, r[metric] * multiplier));
  });
} // returns an array of wattage values


function getProductionSummed(timeSeries, productionGrouping) {
  // by default, filter for all production grouping types
  // if productionGrouping is passed in, will filter only for that type
  var timeSeriesProduction = timeSeries.filter(hardwareUtils.registerIsProduction); // if no production exist, just send an array of 0s, keeping the math simple

  if (timeSeries.length && !timeSeriesProduction.length) {
    return timeSeries[0].values.map(function () {
      return 0;
    });
  }

  return timeSeries.length ? sumTimeSeriesWattage(timeSeriesProduction) : null;
} // returns an array of objects with wattage values and timestamps


function getProductionSeries(timeSeries, productionGrouping) {
  var valueGroupWithMostData = snapshotUtils.getSnapshotWithMostData(timeSeries.map(function (circuit) {
    return circuit.values;
  }));
  return (getProductionSummed(timeSeries, productionGrouping) || []).map(function (val, i) {
    return {
      w: val,
      t: valueGroupWithMostData[i].t
    };
  });
}

function getBatterySummed(timeSeries) {
  var timeSeriesBattery = timeSeries.filter(hardwareUtils.registerIsBattery);

  if (timeSeries.length && !timeSeriesBattery.length) {
    return timeSeries[0].values.map(function () {
      return 0;
    });
  }

  return timeSeries.length ? sumTimeSeriesWattage(timeSeriesBattery) : null;
}

function getBatterySeries(timeSeries, options) {
  var timeSeriesBattery = timeSeries.filter(hardwareUtils.registerIsBattery);
  var valueGroupWithMostData = snapshotUtils.getSnapshotWithMostData(timeSeries.map(function (circuit) {
    return circuit.values;
  }));
  return sumTimeSeriesWattage(timeSeriesBattery, options).map(function (val, i) {
    return {
      w: val,
      t: valueGroupWithMostData[i].t
    };
  });
}

function getNetSeries(timeSeries, options) {
  var gridSeries = timeSeries.filter(function (r) {
    return r && r.grid;
  }); // use all circuits if no grid circuits are found

  if (!gridSeries.length) {
    gridSeries = timeSeries;
  }

  var valueGroupWithMostData = snapshotUtils.getSnapshotWithMostData(gridSeries.map(function (circuit) {
    return circuit.values;
  }));
  return sumTimeSeriesWattage(gridSeries, options).map(function (val, i) {
    return {
      w: val,
      t: valueGroupWithMostData[i].t
    };
  });
}

function getDateRange(timeString) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  var timezone = arguments.length > 3 ? arguments[3] : undefined;

  var _parseTimeString = parseTimeString(timeString),
      magnitude = _parseTimeString.magnitude,
      unit = _parseTimeString.unit,
      seconds = _parseTimeString.seconds;

  var resolution = getCoarsestResolutionForRange({
    start: 0,
    end: seconds
  });

  if (typeof offset === 'string') {
    offset = parseTimeString(offset).seconds;
  }

  end = normalizeDateToTimestamp(end) - offset;
  var endMoment = moment(end * 1000);

  if (timezone) {
    endMoment.tz(timezone);
  } // if we're using days, then always go to the start of the current day


  if (resolution === 'd') {
    endMoment.startOf(momentTimeGroupings[unit]);
  } // otherwise, just subtract mod seconds
  else {
    endMoment.subtract(Math.floor(endMoment.valueOf() / 1000) % allowedResolutions[resolution], 'seconds');
  }

  var startMoment = moment(endMoment).subtract(magnitude, momentTimeGroupings[unit]);
  endMoment.subtract(1, 'second').toDate();

  function momentToTimestamp(m) {
    return Math.floor(m.toDate().getTime() / 1000);
  }

  return {
    end: end,
    start: momentToTimestamp(startMoment),
    endDate: new Date(end * 1000),
    startDate: startMoment.toDate()
  };
}

function endOfInterval(interval) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

  if (time instanceof Date) {
    time = Math.floor(time.getTime() / 1000);
  }

  return time - time % parseTimeString(interval).seconds;
}

function getExpirationForResolution(resolution) {
  var _parseTimeString2 = parseTimeString(resolution),
      seconds = _parseTimeString2.seconds; // 12 hours is the maximum for any cache


  return Math.min(Math.round(!isNaN(seconds) ? seconds : 0), 60 * 60 * 12);
}

function getLargestResolutionForKwhTimeRange(start, end) {
  if (start % 86400 === 0 && end % 86400 === 86399) {
    return 'd';
  }

  if (start % 3600 === 0 && end % 3600 === 3599) {
    return 'h';
  }

  if (start % 300 === 0 && end % 300 === 299) {
    return '5m';
  }

  return 'm';
}

function getLargestResolutionForSeconds(seconds) {
  if (seconds % 86400 === 0) {
    return 'd';
  }

  if (seconds % 3600 === 0) {
    return 'h';
  }

  if (seconds % 300 === 0) {
    return '5m';
  }

  return 'm';
}

function validateResolution(resolution) {
  if (!resolution) {
    throw new BadRequestError('"resolution" is required');
  }

  var resolutions = Object.keys(allowedResolutions);

  if (!resolutions.includes(resolution)) {
    throw new BadRequestError("\"".concat(resolution, "\" is not a valid resolution.  Must be one of ").concat(resolutions.join(', ')));
  }
} // pick the coarsest resolution that can correctly cover 80% of the time range 


function getCoarsestResolutionForRange(_ref3) {
  var start = _ref3.start,
      end = _ref3.end,
      _ref3$overflowBuffer = _ref3.overflowBuffer,
      overflowBuffer = _ref3$overflowBuffer === void 0 ? 0.2 : _ref3$overflowBuffer;
  start = normalizeDateToTimestamp(start);
  end = normalizeDateToTimestamp(end);
  var rangeSeconds = end - start;

  var _iterator2 = _createForOfIteratorHelper(resolutionsMap),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          resolution = _step2$value[0],
          seconds = _step2$value[1];

      var secondsSinceRecentMilestone = start % seconds; // find the first milestone, marking where our query will start

      var firstMilestone = secondsSinceRecentMilestone === 0 ? start : start - secondsSinceRecentMilestone; // the last milestone in the range is where the last chunk begins

      var lastMilestone = firstMilestone + Math.floor((end - firstMilestone) / seconds) * seconds;

      if (lastMilestone <= firstMilestone) {
        continue;
      } // the representative range goes from the first milestone to the last milestone + range seconds
      // because the historical service will include an entire resolution chunk even if end time is only 1s beyond the milestone


      var representativeSeconds = lastMilestone + seconds - firstMilestone - 1; // if the range represented by the milestones

      var representativeProportion = representativeSeconds / rangeSeconds;

      if (representativeProportion >= 1 - overflowBuffer && representativeProportion <= 1 + overflowBuffer) {
        return resolution;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return 'm';
}

function getInterpolatedFlatSample(_ref4) {
  var prev = _ref4.prev,
      next = _ref4.next,
      t = _ref4.t;
  var valueScale = d3Scale.scaleLinear().domain([prev.t, next.t]).clamp(true);
  return _objectSpread(_objectSpread({}, prev), {}, {
    t: t,
    interpolated: true,
    g: (prev.g || []).map(function (g, gi) {
      Object.keys(g).forEach(function (k) {
        var prevValue = g[k],
            nextValue = next.g[gi][k];

        if (typeof prevValue === 'number' && typeof nextValue === 'number') {
          g[k] = valueScale.range([prevValue, nextValue])(t);
        }
      });
      return g;
    }),
    c: prev.c.map(function (c, ci) {
      Object.keys(c).forEach(function (k) {
        var prevValue = c[k],
            nextValue = next.c[ci][k];

        if (typeof prevValue === 'number' && typeof nextValue === 'number') {
          c[k] = valueScale.range([prevValue, nextValue])(t);
        }
      });
      return c;
    })
  });
}

function duplicateWithAllNumericValuesReplaced(arr, replacement) {
  if (!Array.isArray(arr)) {
    return arr;
  }

  return arr.map(function (item) {
    var replaced = _objectSpread({}, item);

    Object.keys(replaced).forEach(function (k) {
      if (typeof item[k] === 'number') {
        replaced[k] = replacement;
      }
    });
    return replaced;
  });
}
/**
 * @param {*} flatSample 
 * @param {*} t 
 */


function getMockFlatSample(_ref5) {
  var template = _ref5.template,
      t = _ref5.t,
      _ref5$replacement = _ref5.replacement,
      replacement = _ref5$replacement === void 0 ? null : _ref5$replacement;
  return _objectSpread(_objectSpread({}, template), {}, {
    t: t,
    g: duplicateWithAllNumericValuesReplaced(template.g, replacement),
    c: duplicateWithAllNumericValuesReplaced(template.c, replacement)
  });
}
/* 
- accepts an array of flatSamples, (output from `sampleMappingUtils.flattenSample`).  These are expected to already be sorted by timestamp
- hubs with the same timestamp are merged together and their contents concatenated
- returns a array of merged flat samples
optional params:
  start: a timestamp of the start of the range. defaults to the first timestamp in flatSamples
  end: a timestamp for the end of the range. defaults to last timestamp in flatSamples
  fill_all_gaps: boolean to fill any missing data in the data range.  by default, missing data will be filled with `null`.  if `interpolate` is true, will be filled with interpolated data
  interpolate: linear interpolate partial data.  if used with `fill_all_gaps`, will interpolate all missing data
  omit_future_samples: if true, this will remove any samples that have not fully completed. for example, if using resolution=d, today's UTC day data will be omitted from the response
*/


function mergeFlatSamples(_ref6) {
  var _ref6$flatSamples = _ref6.flatSamples,
      flatSamples = _ref6$flatSamples === void 0 ? [] : _ref6$flatSamples,
      _ref6$start = _ref6.start,
      start = _ref6$start === void 0 ? flatSamples[0].t : _ref6$start,
      _ref6$end = _ref6.end,
      end = _ref6$end === void 0 ? flatSamples[flatSamples.length - 1].t : _ref6$end,
      fill_all_gaps = _ref6.fill_all_gaps,
      interpolate = _ref6.interpolate,
      omit_future_samples = _ref6.omit_future_samples;
  // sort by timestamp
  var needsResort = false;
  var hubOrder = Array.from(new Set(flatSamples.map(function (fs) {
    return fs.h;
  })));
  var flatSamplesByHub = {};

  if (!flatSamples.length) {
    return flatSamples;
  }

  function sortSamples() {
    flatSamples.sort(function (a, b) {
      return a.t - b.t;
    });
    needsResort = false;
  }

  ;

  function addSyntheticSample(sample) {
    flatSamples.push(_objectSpread({
      synthetic: true
    }, sample));
    needsResort = true;
  }

  ;
  sortSamples(); // group by hub serial

  flatSamples.forEach(function (fs) {
    var list = flatSamplesByHub[fs.h] || (flatSamplesByHub[fs.h] = []);
    list.push(fs);
  });
  var serials = Object.keys(flatSamplesByHub); // const registerConfig = serials.reduce(
  //   (acc, serial) => {
  //     const fs = flatSamplesByHub[serial][0];
  //     if(fs && fs.registerConfig){
  //       acc = acc.concat(fs.registerConfig);
  //     }
  //     return acc;
  //   },
  //   []
  // );
  // add interpolated data for any and all missing gaps between `start` and `end`

  if (fill_all_gaps) {
    if (needsResort) {
      sortSamples();
    }

    Object.keys(flatSamplesByHub).forEach(function (serial) {
      var list = flatSamplesByHub[serial];
      var seconds = list[0].seconds;
      var idealTimestamps = getIdealTimestampsForRange({
        start: normalizeDateToTimestamp(start),
        end: normalizeDateToTimestamp(end),
        seconds: seconds
      });

      if (omit_future_samples) {
        var now = Math.floor(Date.now() / 1000); // allow some buffer for samples to arrive

        var sampleLatencySeconds = 100;
        idealTimestamps = idealTimestamps.filter(function (t) {
          return t + seconds + sampleLatencySeconds < now;
        });
      }

      var prev = list[0];
      var next = list[list.length - 1]; // step through all ideal timestamps and if you find missing samples, add an interpolated sample

      idealTimestamps.forEach(function (t, i) {
        var matchingSample = list.find(function (ts) {
          return ts.t === t;
        });

        if (!matchingSample) {
          if (interpolate) {
            // no timestamped snapshot found, so interpolate based on nearby data              
            prev = list[i - 1] ? list[i - 1] : prev;
            next = list[i] ? list[i] : next;
            addSyntheticSample(getInterpolatedFlatSample({
              prev: prev,
              next: next,
              t: t
            }));
          } else {
            addSyntheticSample(getMockFlatSample({
              template: prev,
              t: t
            }));
          }
        }
      });
    });
  } // if there are timestamps that we have not all hubs reporting, 
  // add interpolated samples for non reporting hub(s)
  else {
    var _flatSamples$reduce = flatSamples.reduce(function (acc, _ref7) {
      var t = _ref7.t;

      var _acc = _slicedToArray(acc, 2),
          partialTimestamps = _acc[0],
          timestamps = _acc[1];

      var samplesWithTimestamp = flatSamples.filter(function (fs) {
        return fs.t === t;
      });

      if (samplesWithTimestamp.length < serials.length) {
        var serialsReporting = samplesWithTimestamp.map(function (s) {
          return s.h;
        });
        partialTimestamps.push({
          t: t,
          nonReportingHubs: serials.filter(function (s) {
            return !serialsReporting.find(function (_s) {
              return _s === s;
            });
          })
        });
      }

      if (timestamps.indexOf(t) === -1) {
        timestamps.push(t);
      }

      return acc;
    }, [[], []]),
        _flatSamples$reduce2 = _slicedToArray(_flatSamples$reduce, 2),
        partialTimestamps = _flatSamples$reduce2[0],
        timestamps = _flatSamples$reduce2[1]; // for each partial timestamp, fill in data for non reporting hubs


    partialTimestamps.forEach(function (_ref8) {
      var t = _ref8.t,
          nonReportingHubs = _ref8.nonReportingHubs;
      nonReportingHubs.forEach(function (serial) {
        var list = flatSamplesByHub[serial];

        if (interpolate) {
          var prev = list[0];
          var next = list[list.length - 1]; // find nearby samples and interpolate

          for (var i = 0; i < list.length; i++) {
            var item = list[i];

            if (item.t > t) {
              next = item;

              if (i) {
                prev = list[i - 1];
              }

              addSyntheticSample(getInterpolatedFlatSample({
                prev: prev,
                next: next,
                t: t
              }));
            }
          }
        } else {
          // use null
          addSyntheticSample(getMockFlatSample({
            template: list[0],
            t: t
          }));
        }
      });
    });
  }

  if (needsResort) {
    sortSamples();
  } // preserve hub order


  if (hubOrder.length > 1) {
    flatSamples.sort(function (a, b) {
      if (a.t === b.t) {
        return hubOrder.indexOf(a.h) - hubOrder.indexOf(b.h);
      }

      return a.t - b.t;
    });
  } // find samples tagged with `fetchMoreFromHere` which indicates that there is/are additional "pages"
  // of samples to be requested from the historical API. so we take the earliest of any samples tagged with this
  // to ensure that we fetch all available samples


  var earliestFetchMoreTimestamp = flatSamples.reduce(function (acc, fs) {
    if (fs.fetchMoreFromHere && (acc === null || fs.t < acc)) {
      acc = fs.t;
    }

    return acc;
  }, null); // merge 

  return flatSamples.reduce(function (acc, _ref9) {
    var t = _ref9.t;

    if (!acc.find(function (fs) {
      return fs.t === t;
    })) {
      var samplesWithTimestamp = flatSamples.filter(function (fs) {
        return fs.t === t;
      });
      var hasHubsOnline = samplesWithTimestamp.filter(function (s) {
        return s.hasOwnProperty('hub_online');
      }).length > 0;
      acc.push(_.mergeWith.apply(_, [{
        hubs: samplesWithTimestamp.map(function (fs) {
          return fs.h;
        }),
        onlineHubs: hasHubsOnline ? samplesWithTimestamp.filter(function (v) {
          return v.hub_online;
        }).map(function (fs) {
          return fs.h;
        }) : undefined,
        syntheticHubs: samplesWithTimestamp.filter(function (v) {
          return v.synthetic;
        }).map(function (fs) {
          return fs.h;
        }),
        interpolatedHubs: samplesWithTimestamp.filter(function (v) {
          return v.interpolated;
        }).map(function (fs) {
          return fs.h;
        })
      }].concat(_toConsumableArray(samplesWithTimestamp), [{
        fetchMoreFromHere: t === earliestFetchMoreTimestamp ? true : undefined
      }, function customizer(objValue, srcValue) {
        if (_.isArray(objValue)) {
          return objValue.concat(srcValue);
        }
      }])));
    }

    return acc;
  }, []);
}

function addOtherToFlatSample(fs) {
  var other = snapshotUtils.addOther(fs.c);

  if (other) {
    fs.c.push(other);
    fs.registerConfig.push(other.register);
  }
}

function addOtherToFlatSamples(flatSamples) {
  flatSamples.forEach(addOtherToFlatSample);
}

function addCostToFlatSample(_ref10) {
  var flatSample = _ref10.flatSample,
      locationBilling = _ref10.locationBilling;
  var simple_kwh_price = locationBilling.simple_kwh_price; // TODO, use ToU rate bands from genability  

  flatSample.c.forEach(function (c) {
    c['cost'] = c.kwh * simple_kwh_price;
    c['cost_30d'] = c.w / 1000 * 24 * 30 * simple_kwh_price;
  });
}

function binFlatSamplesToBands(_ref11) {
  var flatSamples = _ref11.flatSamples,
      bands = _ref11.bands,
      paginationParams = _ref11.paginationParams;

  if (!Array.isArray(bands) || !bands.length) {
    throw new BadRequestError('`bands` must be an array of objects with `start` and `end` dates');
  } // normalize dates


  var bins = bands.map(function (band) {
    return _objectSpread(_objectSpread({}, band), {}, {
      t_start: normalizeDateToTimestamp(band.start),
      t_end: normalizeDateToTimestamp(band.end),
      items: []
    });
  }).reverse();

  var _iterator3 = _createForOfIteratorHelper(flatSamples),
      _step3;

  try {
    var _loop3 = function _loop3() {
      var flatSample = _step3.value;
      var matchingBin = bins.find(function (_ref16) {
        var t_start = _ref16.t_start,
            t_end = _ref16.t_end;
        return [flatSample.t, flatSample.t + flatSample.seconds - 1].some(function (t) {
          return t >= t_start && flatSample.t <= t_end;
        });
      });

      if (matchingBin) {
        matchingBin.items.push(flatSample);
      }
    };

    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop3();
    } // reverse back

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  bins.reverse();
  var propsToNormalize = ['p', 'var'];
  var cumulativeProps = ['kwh', 'cost'];
  return bins.filter(function (_ref12) {
    var items = _ref12.items;
    return items.length;
  }).map(function (_ref13) {
    var t_end = _ref13.t_end,
        t_start = _ref13.t_start,
        items = _ref13.items,
        bandSeconds = _ref13.seconds,
        partial = _ref13.partial;
    // merge items into a single flat sample
    var _items$ = items[0],
        seconds = _items$.seconds,
        c = _items$.c,
        t = _items$.t;
    var idealItemsLength = Math.floor(bandSeconds / seconds);
    var totalSeconds = items[items.length - 1].t - t + seconds;

    var _items$reduce = items.reduce(function (acc, _ref14) {
      var hubs = _ref14.hubs,
          syntheticHubs = _ref14.syntheticHubs;
      acc[0] += hubs.length - syntheticHubs.length;
      acc[1] += syntheticHubs.length;
      return acc;
    }, [0, 0]),
        _items$reduce2 = _slicedToArray(_items$reduce, 2),
        binnedRealSamplesCount = _items$reduce2[0],
        binnedSyntheticSamplesCount = _items$reduce2[1];

    return _objectSpread(_objectSpread({}, items[0]), {}, {
      binnedSamplesCount: items.length,
      binnedRealSamplesCount: binnedRealSamplesCount,
      binnedSyntheticSamplesCount: binnedSyntheticSamplesCount,
      seconds: totalSeconds,
      intervalBand: {
        incomplete: partial ? true : undefined,
        range: [t_start, t_end],
        samples_count: items.length,
        seconds: bandSeconds
      },
      c: c.map(function (c, i) {
        var circuitValues = _objectSpread({}, c);

        var _loop2 = function _loop2() {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
              k = _Object$entries$_i[0],
              v = _Object$entries$_i[1];

          if (!isNumericalProperty(k)) {
            return "continue";
          }

          var value = d3Array.sum(items.map(function (_ref15) {
            var c = _ref15.c;
            var v = c[i][k];
            return propsToNormalize.includes(k) ? Math.abs(v) : v;
          })); // non cumulative props get averaged instead of summed

          if (!cumulativeProps.includes(k)) {
            value /= idealItemsLength;
          }

          circuitValues[k] = value;
        };

        for (var _i2 = 0, _Object$entries = Object.entries(c); _i2 < _Object$entries.length; _i2++) {
          var _ret2 = _loop2();

          if (_ret2 === "continue") continue;
        }

        return circuitValues;
      })
    });
  });
}

var energyUnits = {
  w: {
    name: 'real power',
    unit: 'W',
    level: 'c'
  },
  avg: {
    name: 'average real power',
    unit: 'W',
    level: 'c'
  },
  min: {
    name: 'minimum real power',
    unit: 'W',
    level: 'c'
  },
  max: {
    name: 'maximum real power',
    unit: 'W',
    level: 'c'
  },
  cost_30d: {
    name: 'monthly cost',
    unit: '{currency_code}/30d',
    level: 'c'
  },
  cost: {
    name: 'cost',
    unit: '{currency_code}',
    level: 'c'
  },
  kwh: {
    name: 'energy',
    unit: 'kWh',
    level: 'c'
  },
  v: {
    name: 'voltage',
    unit: 'V',
    level: 'g'
  },
  i: {
    name: 'current',
    unit: 'A',
    level: 'c'
  },
  'var': {
    name: 'reactive power',
    unit: 'var',
    level: 'c'
  },
  p: {
    name: 'power factor',
    unit: 'cosθ',
    level: 'c'
  }
};

function formatFlatSamples(_ref17) {
  var flatSamples = _ref17.flatSamples,
      _ref17$group_by = _ref17.group_by,
      group_by = _ref17$group_by === void 0 ? 'timestamp' : _ref17$group_by,
      _ref17$channel_metric = _ref17.channel_metrics,
      channel_metrics = _ref17$channel_metric === void 0 ? ['w'] : _ref17$channel_metric,
      _ref17$group_metrics = _ref17.group_metrics,
      group_metrics = _ref17$group_metrics === void 0 ? [] : _ref17$group_metrics,
      _ref17$include_totals = _ref17.include_totals,
      include_totals = _ref17$include_totals === void 0 ? false : _ref17$include_totals,
      _ref17$logger = _ref17.logger,
      logger = _ref17$logger === void 0 ? console : _ref17$logger;

  if (!flatSamples.length) {
    return [];
  }

  var _flatSamples$ = flatSamples[0],
      registerConfig = _flatSamples$.registerConfig,
      _flatSamples$$c = _flatSamples$.c,
      c = _flatSamples$$c === void 0 ? [] : _flatSamples$$c;
  var hasProduction = registerConfig.find(hardwareUtils.registerIsProduction);
  var hasBattery = registerConfig.find(hardwareUtils.registerIsBattery);
  var totals;

  switch (group_by) {
    case 'register':
      var registers = registerConfig.slice(0, c.length).map(function (register, i) {
        return {
          register: hardwareUtils.getLeanRegister(register),
          values: channel_metrics.map(function (k) {
            return {
              unit: k,
              series: flatSamples.map(function (fs) {
                var t = fs.t;
                var c = fs.c[i];

                if (c) {
                  return [t, useSignificantDigits(c[k])];
                }
              }) // remove falsey values
              .filter(function (v) {
                return v;
              })
            };
          })
        };
      });

      if (include_totals) {
        var totalTypes = [['net', snapshotUtils.getGridImpactForFlatSample], ['cons', snapshotUtils.getConsumptionForFlatSample]];

        if (hasProduction) {
          totalTypes.push(['prod', snapshotUtils.getProductionForFlatSample]);
        }

        if (hasBattery) {
          totalTypes.push(['batt', snapshotUtils.getBatteryForFlatSample]);
        }

        totals = totalTypes.map(function (_ref18) {
          var _ref19 = _slicedToArray(_ref18, 2),
              type = _ref19[0],
              getter = _ref19[1];

          return {
            type: type,
            values: channel_metrics.map(function (k) {
              return {
                unit: k,
                series: flatSamples.map(function (fs) {
                  return [fs.t, useSignificantDigits(getter(fs, {
                    metric: k
                  }))];
                })
              };
            })
          };
        });
      }

      return {
        registers: registers,
        totals: totals
      };

    case 'category':
      var categories = hardwareUtils.getAllCategoryIdsForRegisters(registerConfig).map(function (category) {
        return {
          category: category,
          values: channel_metrics.map(function (k) {
            return {
              unit: k,
              series: flatSamples.map(function (fs) {
                var t = fs.t;
                var matchingChannels = fs.c.filter(function (_ref20) {
                  var register = _ref20.register;
                  return hardwareUtils.getCategoryIdFromRegister(register) === category;
                });
                return [t, snapshotUtils.sumReadingsFromChannels(matchingChannels, k)];
              })
            };
          })
        };
      });

      if (include_totals) {
        var _totalTypes = [['net', snapshotUtils.getGridImpactForFlatSample], ['cons', snapshotUtils.getConsumptionForFlatSample]];

        if (hasProduction) {
          _totalTypes.push(['prod', snapshotUtils.getProductionForFlatSample]);
        }

        if (hasBattery) {
          _totalTypes.push(['batt', snapshotUtils.getBatteryForFlatSample]);
        }

        totals = _totalTypes.map(function (_ref21) {
          var _ref22 = _slicedToArray(_ref21, 2),
              type = _ref22[0],
              getter = _ref22[1];

          return {
            type: type,
            values: channel_metrics.map(function (k) {
              return {
                unit: k,
                series: flatSamples.map(function (fs) {
                  return [fs.t, useSignificantDigits(getter(fs, {
                    metric: k
                  }))];
                })
              };
            })
          };
        });
      }

      return {
        categories: categories,
        totals: totals
      };

    case 'timestamp':
    default:
      return flatSamples.map(function (fs) {
        var t = fs.t,
            c = fs.c,
            g = fs.g;
        var result = {
          t: t
        };
        var registerValues = result.r = {}; // extract channel data

        channel_metrics.forEach(function (k) {
          try {
            registerValues[k] = c.map(function (_c) {
              if (!_c.hasOwnProperty(k) && !_c.register.other) {
                throw new Error("Channel does not have the requested key \"".concat(k, "\""));
              }

              return useSignificantDigits(_c[k]);
            });
          } catch (err) {
            logger.error(err.message);
          }
        });

        if (include_totals) {
          var _totals = result.tot = {};

          var _totalTypes2 = [['net', snapshotUtils.getGridImpactForFlatSample], ['cons', snapshotUtils.getConsumptionForFlatSample]];

          if (hasProduction) {
            _totalTypes2.push(['prod', snapshotUtils.getProductionForFlatSample]);
          }

          if (hasBattery) {
            _totalTypes2.push(['batt', snapshotUtils.getBatteryForFlatSample]);
          }

          _totalTypes2.forEach(function (_ref23) {
            var _ref24 = _slicedToArray(_ref23, 2),
                key = _ref24[0],
                getter = _ref24[1];

            var totalValue = _totals[key] = {};
            channel_metrics.forEach(function (k) {
              return totalValue[k] = useSignificantDigits(getter(fs, {
                metric: k
              }));
            });
          });
        }

        if (group_metrics.length) {
          var phaseValues = result.ph = {}; // extract group data

          group_metrics.forEach(function (k) {
            try {
              g.forEach(function (_g) {
                if (!_g.hasOwnProperty(k)) {
                  throw new Error("Group does not have the requested key \"".concat(k, "\""));
                }

                var v = phaseValues[k] = phaseValues[k] || [];
                var phaseArray = v[_g.phase] = v[_g.phase] || [];
                phaseArray.push(useSignificantDigits(_g[k]));
              });
            } catch (err) {
              logger.error(err.message);
            }
          });
        }

        return result;
      });
  }
}

function convertFlatSamplesToAPIResponse(_ref25) {
  var paginationParams = _ref25.paginationParams,
      flatSamples = _ref25.flatSamples,
      _ref25$channel_metric = _ref25.channel_metrics,
      channel_metrics = _ref25$channel_metric === void 0 ? ['w'] : _ref25$channel_metric,
      _ref25$group_metrics = _ref25.group_metrics,
      group_metrics = _ref25$group_metrics === void 0 ? [] : _ref25$group_metrics,
      omit_registers = _ref25.omit_registers,
      group_by = _ref25.group_by,
      describe_intervals = _ref25.describe_intervals,
      include_totals = _ref25.include_totals,
      omit_units = _ref25.omit_units,
      _ref25$currency_code = _ref25.currency_code,
      currency_code = _ref25$currency_code === void 0 ? 'USD' : _ref25$currency_code,
      bands = _ref25.bands;
  var constituentSamples = flatSamples;

  if (Array.isArray(bands) && bands.length) {
    // filter for flatSamples that are complete
    flatSamples = binFlatSamplesToBands({
      flatSamples: flatSamples,
      bands: bands,
      paginationParams: paginationParams
    });
    constituentSamples = flatSamples;
  }

  var _constituentSamples$r = constituentSamples.reduce(function (acc, _ref26) {
    var _ref26$hubs = _ref26.hubs,
        hubs = _ref26$hubs === void 0 ? [] : _ref26$hubs,
        _ref26$syntheticHubs = _ref26.syntheticHubs,
        syntheticHubs = _ref26$syntheticHubs === void 0 ? [] : _ref26$syntheticHubs,
        binnedRealSamplesCount = _ref26.binnedRealSamplesCount,
        binnedSyntheticSamplesCount = _ref26.binnedSyntheticSamplesCount;
    acc[0] += typeof binnedRealSamplesCount === 'number' ? binnedRealSamplesCount : hubs.length - syntheticHubs.length;
    acc[1] += typeof binnedSyntheticSamplesCount === 'number' ? binnedSyntheticSamplesCount : syntheticHubs.length;
    return acc;
  }, [0, 0, 0]),
      _constituentSamples$r2 = _slicedToArray(_constituentSamples$r, 2),
      real_samples_count = _constituentSamples$r2[0],
      synthetic_samples_count = _constituentSamples$r2[1];

  var first = flatSamples[0];
  var last = flatSamples[flatSamples.length - 1];
  var t = first.t,
      resolution = first.resolution,
      hubs = first.hubs,
      registerConfig = first.registerConfig;
  var count = flatSamples.length;
  var dataStart = first.t;
  var dataEnd = last.t + last.seconds - 1;
  var previous = null;
  var next = null;

  if (paginationParams) {
    var requestQueryStart = paginationParams.requestQueryStart,
        requestQueryEnd = paginationParams.requestQueryEnd,
        fullRequestURL = paginationParams.fullRequestURL,
        secondsInPage = paginationParams.secondsInPage;

    if (fullRequestURL) {
      // previous/next pagination
      var pageURLParams = {
        from_now_range: null,
        start: requestQueryStart.toJSON(),
        end: requestQueryEnd.toJSON()
      }; // dataStart is at least one sample ahead of requestQueryStart

      if (requestQueryStart && dataStart - Math.floor(requestQueryStart / 1000) > allowedResolutions[resolution]) {
        // there is a previous page
        previous = addParamsToUrl(_objectSpread(_objectSpread({}, pageURLParams), {}, {
          continue_from: new Date((dataStart - secondsInPage) * 1000).toJSON()
        }), fullRequestURL);
      } // dataEnd is at least one sample behind requestQueryEnd


      if (requestQueryEnd && Math.floor(requestQueryEnd / 1000) - dataEnd > allowedResolutions[resolution]) {
        // there is a next page
        next = addParamsToUrl(_objectSpread(_objectSpread({}, pageURLParams), {}, {
          continue_from: new Date((dataEnd + 1) * 1000).toJSON()
        }), fullRequestURL);
      }
    }
  }

  var interval_bands;

  if (describe_intervals && flatSamples[0].intervalBand) {
    interval_bands = flatSamples.map(function (_ref27) {
      var intervalBand = _ref27.intervalBand;
      return intervalBand;
    });
  }

  return {
    count: count,
    real_samples_count: real_samples_count,
    synthetic_samples_count: synthetic_samples_count,
    start: dataStart,
    end: dataEnd,
    previous: previous,
    next: next,
    resolution: resolution,
    resolution_seconds: allowedResolutions[resolution],
    interval_bands: interval_bands,
    hubs: hubs,
    units: omit_units ? undefined : channel_metrics.concat(group_metrics).map(function (k) {
      var unitDefinition = energyUnits[k];

      if (unitDefinition) {
        var unit = unitDefinition.unit;

        if (unit) {
          unit = unitDefinition.unit = unit.replace(/\{currency_code\}/, currency_code);
        }

        return _objectSpread(_objectSpread({
          key: k
        }, unitDefinition), {}, {
          level: undefined
        });
      }
    }),
    registers: omit_registers || group_by === 'register' ? undefined : registerConfig.map(hardwareUtils.getLeanRegister),
    results: formatFlatSamples({
      flatSamples: flatSamples,
      channel_metrics: channel_metrics,
      group_metrics: group_metrics,
      group_by: group_by,
      include_totals: include_totals
    })
  };
}

function mergeFlatAggregates(_ref28) {
  var flatAggregates = _ref28.flatAggregates;
  return _.mergeWith.apply(_, [{
    t_max_list: flatAggregates.map(function (_ref29) {
      var t_max = _ref29.t_max;
      return t_max;
    }),
    t_min_list: flatAggregates.map(function (_ref30) {
      var t_min = _ref30.t_min;
      return t_min;
    }),
    hubs: flatAggregates.map(function (fa) {
      return fa.h;
    }),
    samples_count: flatAggregates.reduce(function (acc, _ref31) {
      var samples_aggregated = _ref31.samples_aggregated;
      acc += samples_aggregated || 0;
      return acc;
    }, 0)
  }].concat(_toConsumableArray(flatAggregates), [function customizer(objValue, srcValue) {
    if (Array.isArray(objValue)) {
      return objValue.concat(srcValue);
    }
  }]));
}

function addOtherToFlatAggregate(fa) {
  var other = snapshotUtils.addOther(fa.c);

  if (other) {
    fa.c.push(_.omit(other, 'min', 'max'));
  }
}

function addCostToFlatAggregate(_ref32) {
  var flatAggregate = _ref32.flatAggregate,
      locationBilling = _ref32.locationBilling;
  var simple_kwh_price = locationBilling.simple_kwh_price;
  flatAggregate.c.forEach(function (item) {
    var kwh = item.kwh,
        kwhr = item.kwhr;
    var kwhValue = typeof kwh === 'number' ? kwh : kwhr;

    if ([kwhValue, simple_kwh_price].every(function (v) {
      return typeof v === 'number';
    })) {
      item['cost'] = useSignificantDigits(kwhValue * simple_kwh_price);
    }
  });
}

function convertFlatAggregateToAPIResponse(_ref33) {
  var flatAggregate = _ref33.flatAggregate,
      resolution = _ref33.resolution,
      include_totals = _ref33.include_totals,
      include_categories = _ref33.include_categories,
      omit_units = _ref33.omit_units,
      omit_registers = _ref33.omit_registers,
      _ref33$currency_code = _ref33.currency_code,
      currency_code = _ref33$currency_code === void 0 ? 'USD' : _ref33$currency_code;
  var range = {};
  var t_min_list = flatAggregate.t_min_list,
      t_max_list = flatAggregate.t_max_list,
      seconds = flatAggregate.seconds,
      samples_count = flatAggregate.samples_count,
      hubs = flatAggregate.hubs;

  if (Array.isArray(t_min_list)) {
    range.start = Math.min.apply(Math, _toConsumableArray(t_min_list));
  }

  if (Array.isArray(t_max_list)) {
    range.end = Math.max.apply(Math, _toConsumableArray(t_max_list)) + seconds - 1;
  }

  var hasProduction = !!flatAggregate.c.find(function (_ref34) {
    var register = _ref34.register;
    return hardwareUtils.registerIsProduction(register);
  });
  var hasBattery = !!flatAggregate.c.find(function (_ref35) {
    var register = _ref35.register;
    return hardwareUtils.registerIsBattery(register);
  });
  var results = {};

  if (!omit_registers) {
    results.registers = flatAggregate.c.map(function (c) {
      var values = {};
      Object.keys(c).forEach(function (k) {
        if (typeof c[k] === 'number' && k !== 'kwhr') {
          return values[k] = c[k];
        }
      });
      return _objectSpread(_objectSpread({}, values), {}, {
        register: c.register ? hardwareUtils.getLeanRegister(c.register) : undefined
      });
    });
  }

  if (include_categories) {
    var registerConfig = flatAggregate.registerConfig;
    results.categories = hardwareUtils.getAllCategoryIdsForRegisters(registerConfig).map(function (category) {
      var values = {};
      var matchingChannels = flatAggregate.c.filter(function (_ref36) {
        var register = _ref36.register;
        return hardwareUtils.getCategoryIdFromRegister(register) === category;
      });

      if (!matchingChannels.length) {
        return;
      }

      ['avg', 'kwh', 'cost'].forEach(function (k) {
        if (typeof matchingChannels[0][k] === 'number') {
          values[k] = snapshotUtils.sumReadingsFromChannels(matchingChannels, k);
        }
      });
      return _objectSpread({
        category: category
      }, values);
    }).filter(function (s) {
      return s;
    });
  }

  if (include_totals) {
    var totals_metrics = ['kwh', 'cost'];
    var totalTypes = [['net', snapshotUtils.getGridImpactForFlatSample], ['cons', snapshotUtils.getConsumptionForFlatSample]];

    if (hasProduction) {
      totalTypes.push(['prod', snapshotUtils.getProductionForFlatSample]);
    }

    if (hasBattery) {
      totalTypes.push(['batt', snapshotUtils.getBatteryForFlatSample]);
    }

    results.totals = totalTypes.map(function (_ref37) {
      var _ref38 = _slicedToArray(_ref37, 2),
          type = _ref38[0],
          getter = _ref38[1];

      var r = {
        type: type
      };
      totals_metrics.forEach(function (k) {
        if (typeof flatAggregate.c[0][k] === 'number') {
          r[k] = useSignificantDigits(getter(flatAggregate, {
            metric: k
          }));
        }
      });
      return r;
    });
  }

  return _objectSpread(_objectSpread({
    samples_count: samples_count
  }, range), {}, {
    hubs: hubs,
    resolution: resolution,
    units: omit_units ? undefined : ['kwh', 'cost', 'avg', 'min', 'max'].filter(function (k) {
      return typeof flatAggregate.c[0][k] === 'number';
    }).map(function (k) {
      var unitDefinition = energyUnits[k];

      if (unitDefinition) {
        var unit = unitDefinition.unit;

        if (unit) {
          unit = unitDefinition.unit = unit.replace(/\{currency_code\}/, currency_code);
        }

        return _objectSpread(_objectSpread({
          key: k
        }, unitDefinition), {}, {
          level: undefined
        });
      }
    }),
    results: results
  });
} // function combineAggregates(aggregateSnapshots){
//   if(aggregateSnapshots.length){
//     // drill into each circuit, and recalculate aggregate data based on all of the snapshots
//     return aggregateSnapshots[0].map((circuit, i) => {
//       // extract all instances of this circuit
//       const allInstancesOfCircuit = aggregateSnapshots.map(snapshot => snapshot[i]);
//       const sum = allInstancesOfCircuit.reduce((a,b) => a.sum + b.sum, 0);
//       return Object.assign(circuit, {
//         sum: sum,
//         average: sum/allInstancesOfCircuit.length,
//         min: Math.max.apply(this, allInstancesOfCircuit.map(c => c.min)),
//         max: Math.max.apply(this, allInstancesOfCircuit.map(c => c.max))
//       });
//     });
//   }
// }


function getIdealTimestampsForRange(_ref39) {
  var start = _ref39.start,
      end = _ref39.end,
      seconds = _ref39.seconds;
  var secondsSinceLastMilestone = start % seconds;
  var firstMilestone = secondsSinceLastMilestone === 0 ? start : start - secondsSinceLastMilestone + seconds;
  var samples = [];
  var t = firstMilestone;

  while (t < end) {
    samples.push(t);
    t += seconds;
  }

  return samples;
}

function normalizeDateToTimestamp(t) {
  if (t instanceof Date) {
    return Math.floor(t.getTime() / 1000);
  }

  return parseInt(t, 10);
}

function quantizeTimestamp(timeString, fromTime, timezone) {
  // this method takes fromTime, and gets the beginning of whatever unit it belongs to
  // it's sort of like a snapTo that always snaps back
  var _parseTimeString3 = parseTimeString(timeString),
      unit = _parseTimeString3.unit,
      seconds = _parseTimeString3.seconds;

  switch (unit) {
    // case 'm':
    //   return fromTime - (fromTime % 60);
    // case '5m':
    //   return fromTime - (fromTime % (60 * 5));
    // case '30m':
    //   return fromTime - (fromTime % (60 * 30));
    // case 'h':
    //   return fromTime - (fromTime % (60 * 60));
    case 'd':
      return Math.floor(moment.unix(fromTime).tz(timezone).startOf('day').valueOf() / 1000);

    case 'w':
      return Math.floor(moment.unix(fromTime).tz(timezone).startOf('isoweek').valueOf() / 1000);

    case 'mo':
      return Math.floor(moment.unix(fromTime).tz(timezone).startOf('month').valueOf() / 1000);

    case 'y':
      return Math.floor(moment.unix(fromTime).tz(timezone).startOf('year').valueOf() / 1000);

    default:
      return fromTime - fromTime % seconds;
  }
}

var momentTimeGroupings = {
  y: 'year',
  mo: 'month',
  w: 'isoweek',
  d: 'day',
  h: 'hour',
  m: 'minute',
  s: 'second'
};

function getQuantizedBands(_ref40) {
  var start = _ref40.start,
      end = _ref40.end,
      band_size = _ref40.band_size,
      timezone = _ref40.timezone;
  var bands = [];
  var bandRange = parseTimeString(band_size);
  var currentEnd = end;

  if (momentTimeGroupings[bandRange.unit]) {
    // get the resolution from the band range and quantize to the end of the previous unit
    var _parseTimeString4 = parseTimeString(getCoarsestResolutionForRange({
      start: 0,
      end: bandRange.seconds,
      overflowBuffer: 0.05
    })),
        resolutionUnit = _parseTimeString4.unit;

    currentEnd = moment(end).tz(timezone).startOf(momentTimeGroupings[resolutionUnit]).subtract(1, 'seconds').toDate();
  }

  function addBand(currentStart) {
    bands.push({
      start: currentStart,
      end: currentEnd
    });
    currentEnd = moment(currentStart).subtract(1, 'seconds').toDate();
  }

  function getQuantizedStart(end) {
    switch (bandRange.unit) {
      case 'y':
      case 'mo':
        return moment(end).tz(timezone).startOf(momentTimeGroupings[bandRange.unit]).subtract(bandRange.magnitude - 1, momentTimeGroupings[bandRange.unit]).toDate();

      case 'w':
      case 'd':
        return moment(end).tz(timezone).subtract(bandRange.seconds / bandRange.magnitude * (bandRange.magnitude - 1), 'seconds').startOf(momentTimeGroupings[bandRange.unit]).toDate();

      default:
        return moment(end).subtract(Math.floor(end.getTime() / 1000) % bandRange.seconds, 'seconds').toDate();
    }
  }

  ;

  while (currentEnd > start) {
    addBand(getQuantizedStart(currentEnd));
  } // quantize the first band's end to the true end of the band


  if (momentTimeGroupings[bandRange.unit]) {
    var momentTimeGroup = momentTimeGroupings[bandRange.unit];
    bands[0].end = moment(bands[0].start).tz(timezone).add(bandRange.magnitude - 1, momentTimeGroup).endOf(momentTimeGroup).toDate();
  }

  return bands.map(function (_ref41) {
    var start = _ref41.start,
        end = _ref41.end,
        rest = _objectWithoutProperties(_ref41, _excluded);

    var seconds = Math.floor((end - start) / 1000) + 1;
    return _objectSpread({
      start: start,
      end: end,
      seconds: seconds,
      partial: Date.now() < end,
      // TODO, this 0.05 is not ideal, but it works
      resolution: getCoarsestResolutionForRange({
        start: start,
        end: end,
        overflowBuffer: 0.05
      })
    }, rest);
  }).reverse();
}
/*
* The purpose of this function is to generate a list of flat samples in the past or future
* from a given list of real flat samples.  It will first try to find samples by:
  * looking at the same time/date in different year, 
  * looking at the same time/day of week in a different week
  * looking at the same time in a different day
  * if all of the above fail, it will just using nearby data
* Accepts a list of flatSamples, and a start and end date range
*/


function getProjectedFlatSamples(_ref42) {
  var flatSamples = _ref42.flatSamples,
      start = _ref42.start,
      end = _ref42.end;

  if (!flatSamples.length) {
    return [];
  }

  start = normalizeDateToTimestamp(start);
  end = normalizeDateToTimestamp(end);
  var seconds = flatSamples[0].seconds;
  var idealTimestamps = getIdealTimestampsForRange({
    start: start,
    end: end,
    seconds: seconds
  });

  var _d3Array$extent = d3Array.extent(flatSamples.map(function (fs) {
    return fs.t;
  })),
      _d3Array$extent2 = _slicedToArray(_d3Array$extent, 2),
      dataStart = _d3Array$extent2[0],
      dataEnd = _d3Array$extent2[1];

  var idealIntervalsSeconds = [60 * 60 * 24 * 7 * 52, 60 * 60 * 24 * 7, 60 * 60 * 24, seconds];
  var foundSyntheticSample = false;

  function addSyntheticFlatSample(flatSample, t) {
    flatSamples.push(_objectSpread(_objectSpread({}, _.cloneDeep(flatSample)), {}, {
      t: t,
      synthetic: true
    }));
    dataStart = Math.min(dataStart, t);
    dataEnd = Math.max(dataEnd, t);
    foundSyntheticSample = true;
  } // step through ideal timestamps and try to find an analagous sample for each


  var _iterator4 = _createForOfIteratorHelper(idealTimestamps),
      _step4;

  try {
    var _loop4 = function _loop4() {
      var t = _step4.value;

      if (!flatSamples.find(function (fs) {
        return fs.t === t;
      })) {
        (function () {
          // our ideal range is missing a sample, so try and find one
          var analagousFlatSample;

          var _iterator5 = _createForOfIteratorHelper(idealIntervalsSeconds),
              _step5;

          try {
            var _loop5 = function _loop5() {
              var intervalSeconds = _step5.value;
              // start looking forwards
              var tSearch = t;

              var iterate = function iterate() {
                tSearch += intervalSeconds;
              };

              var condition = function condition() {
                return !analagousFlatSample && tSearch >= start && tSearch <= dataEnd;
              };

              iterate();

              while (condition()) {
                analagousFlatSample = flatSamples.find(function (fs) {
                  return fs.t === tSearch;
                });
                iterate();
              } // reset and start looking backwards


              tSearch = t;

              iterate = function iterate() {
                tSearch -= intervalSeconds;
              };

              condition = function condition() {
                return !analagousFlatSample && tSearch <= end && tSearch >= dataStart;
              };

              iterate();

              while (condition()) {
                analagousFlatSample = flatSamples.find(function (fs) {
                  return fs.t === tSearch;
                });
                iterate();
              } // add flat sample if found


              if (analagousFlatSample) {
                addSyntheticFlatSample(analagousFlatSample, t);
                return "break";
              }
            };

            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _ret3 = _loop5();

              if (_ret3 === "break") break;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        })();
      }
    };

    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop4();
    } // if we found synthetic samples, resort

  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (foundSyntheticSample) {
    flatSamples.sort(function (a, b) {
      return a.t - b.t;
    });
  }

  return flatSamples;
}

module.exports = {
  allowedTimeUnits: allowedTimeUnits,
  allowedResolutions: allowedResolutions,
  resolutionsMap: resolutionsMap,
  getRangeMagnitude: getRangeMagnitude,
  getRangeUnit: getRangeUnit,
  parseTimeString: parseTimeString,
  getDateRange: getDateRange,
  endOfInterval: endOfInterval,
  getExpirationForResolution: getExpirationForResolution,
  getLargestResolutionForSeconds: getLargestResolutionForSeconds,
  getLargestResolutionForKwhTimeRange: getLargestResolutionForKwhTimeRange,
  getCoarsestResolutionForRange: getCoarsestResolutionForRange,
  addTimeSeriesTotals: addTimeSeriesTotals,
  sumTimeSeriesWattage: sumTimeSeriesWattage,
  mergeTimestampedSnapshots: mergeTimestampedSnapshots,
  mapSnapshotsWithTimestampsToTimeSeries: mapSnapshotsWithTimestampsToTimeSeries,
  fillDataGapsInTimeSeries: fillDataGapsInTimeSeries,
  interpolatePartialSnapshots: interpolatePartialSnapshots,
  interpolateMissingTimestampedSnapshots: interpolateMissingTimestampedSnapshots,
  omitPartialSnapshots: omitPartialSnapshots,
  getMainsSummed: getMainsSummed,
  getProductionSummed: getProductionSummed,
  getConsumptionSeries: getConsumptionSeries,
  getProductionSeries: getProductionSeries,
  getNetSeries: getNetSeries,
  getBatterySummed: getBatterySummed,
  getBatterySeries: getBatterySeries,
  multiplyTimeSeries: multiplyTimeSeries,
  mergeFlatSamples: mergeFlatSamples,
  getIdealTimestampsForRange: getIdealTimestampsForRange,
  addOtherToFlatSample: addOtherToFlatSample,
  addOtherToFlatSamples: addOtherToFlatSamples,
  addCostToFlatSample: addCostToFlatSample,
  convertFlatSamplesToAPIResponse: convertFlatSamplesToAPIResponse,
  convertFlatAggregateToAPIResponse: convertFlatAggregateToAPIResponse,
  mergeFlatAggregates: mergeFlatAggregates,
  addOtherToFlatAggregate: addOtherToFlatAggregate,
  addCostToFlatAggregate: addCostToFlatAggregate,
  normalizeDateToTimestamp: normalizeDateToTimestamp,
  quantizeTimestamp: quantizeTimestamp,
  getQuantizedBands: getQuantizedBands,
  getProjectedFlatSamples: getProjectedFlatSamples,
  validateResolution: validateResolution,
  binFlatSamplesToBands: binFlatSamplesToBands
};